import React, { memo, useMemo, useState } from "react";
import Video from "react-native-video";

interface Props {}

const VideoModal = memo(
  ({
    imagePreviewStyle = {},
    maxHeight,
    commentaryWidth = width * 0.8,
    imagePreview = "",
    resizeMode = "contain",
    showOnStart = true,
    source,
  }: Props) => {
    const { uri } = source || { uri: "" };

    const goodSource = useMemo(() => {
      return { uri };
    }, [uri]);

    const isBlob =
      typeof uri === "string" &&
      !!uri &&
      uri !== undefined &&
      uri !== null &&
      uri !== "" &&
      uri?.search("blob") === 0;

    return (
      <>
        {isBlob && (
          <video
            src={uri}
            style={imagePreviewStyle}
            controls
            autoPlay={false}
          />
        )}
        {!isBlob && typeof uri === "string" && (
          <Video
            source={goodSource}
            style={imagePreviewStyle}
            autoPlay={false}
          />
        )}
      </>
    );
  },
);

export { VideoModal };
